module.exports = __webpack_public_path__ + "static/how_it_works_multilayers_art@2x-c5f9e19ea5e183761272e52dd57ab946.png";